<template>
  <div class="rt-content-tab">
    <el-tabs v-bind="$attrs" v-model="selectedValue" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :label="item.label"
        :name="item.name"
        :key="index"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'RtContentTabs',
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    handleClick(val) {
      this.$emit('input', val.name);
    }
  }
};
</script>
<style lang="less">
.rt-content-tab {
  .el-tabs--top {
    background: white;
    .el-tabs__header.is-top {
      margin: 0;
      .el-tabs__item.is-top {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        color: #6388c2;
        font-weight: 500;
        padding: 0 40px;
      }
      .el-tabs__item.is-top.is-active {
        color: #1890ff;
      }
      .el-tabs__active-bar.is-top {
        // background-color: #6388c2;
        height: 3px;
        border-radius: 1px;
      }
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtContentTabs.vue?0a766bbf